import script from "./StoryCreated.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCreated.vue?vue&type=script&lang=js"
export * from "./StoryCreated.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCreated.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/base-story-card/StoryCreated.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a849de4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a849de4a', __exports__)) {
    api.reload('a849de4a', __exports__)
  }
  
}


export default __exports__